var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-ai-playground" }, [
    _c("div", { staticClass: "row gutter-md" }, [
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c(
            "q-card",
            [
              _c("q-card-main", [
                _c(
                  "div",
                  { staticClass: "row items-end gutter-sm" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-3 col-xs-12 q-mb-sm" },
                      [
                        _c(
                          "q-field",
                          { attrs: { "stack-label": "Agent" } },
                          [
                            _c(
                              "q-btn-group",
                              { attrs: { outline: "" } },
                              _vm._l(_vm.agentOptions, function(opt) {
                                return _c("q-btn", {
                                  key: opt.value,
                                  attrs: {
                                    size: "md",
                                    "no-caps": "",
                                    color:
                                      _vm.selectedAgent === opt.value
                                        ? "primary"
                                        : "",
                                    label: opt.label
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.onAgentSelect(opt.value)
                                    }
                                  }
                                })
                              })
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-2 col-xs-12 q-mb-sm" },
                      [
                        _c("q-select", {
                          attrs: {
                            options: _vm.promptVersionOptions,
                            "stack-label": "Prompt Version"
                          },
                          on: { input: _vm.onPromptVersionChange },
                          model: {
                            value: _vm.selectedPromptVersion,
                            callback: function($$v) {
                              _vm.selectedPromptVersion = $$v
                            },
                            expression: "selectedPromptVersion"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.selectedAgent === "scheduler"
                      ? _c(
                          "div",
                          { staticClass: "col-md-2 col-xs-12 q-mb-sm" },
                          [
                            _c(
                              "div",
                              { staticClass: "row no-wrap items-end" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("q-select", {
                                      ref: "inquirySelect",
                                      attrs: {
                                        options: _vm.inquiryOptions,
                                        "stack-label": "Select Recent Inquiry"
                                      },
                                      on: { input: _vm.onInquirySelect },
                                      model: {
                                        value: _vm.selectedInquiry,
                                        callback: function($$v) {
                                          _vm.selectedInquiry = $$v
                                        },
                                        expression: "selectedInquiry"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "q-ml-sm" },
                                  [
                                    _c("q-btn", {
                                      attrs: {
                                        flat: "",
                                        dense: "",
                                        round: "",
                                        loading: _vm.isReloadingInquiries,
                                        disable: _vm.isReloadingInquiries,
                                        icon: "refresh",
                                        title: _vm.isReloadingInquiries
                                          ? "Refreshing…"
                                          : "Refresh inquiries"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.reloadInquiriesAndOpen(
                                            $event
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      : _vm.selectedAgent === "receptionist"
                      ? [
                          _c(
                            "div",
                            { staticClass: "col-md-2 col-xs-12 q-mb-sm" },
                            [
                              _c("q-select", {
                                attrs: {
                                  options: _vm.businessOptions,
                                  "stack-label": "Business",
                                  clearable: "",
                                  filter: "",
                                  "emit-value": "",
                                  "map-options": "",
                                  loading: _vm.isLoadingBusinesses,
                                  disable:
                                    _vm.isLoadingBusinesses ||
                                    _vm.businessOptions.length === 0
                                },
                                on: { input: _vm.onBusinessSelect },
                                model: {
                                  value: _vm.selectedBusiness,
                                  callback: function($$v) {
                                    _vm.selectedBusiness = $$v
                                  },
                                  expression: "selectedBusiness"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-2 col-xs-12 q-mb-sm" },
                            [
                              _c(
                                "div",
                                { staticClass: "row no-wrap items-end" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "col" },
                                    [
                                      _c(
                                        "q-field",
                                        [
                                          _c("autocomplete-chips", {
                                            key:
                                              _vm.selectedBusiness ||
                                              "no-business",
                                            attrs: {
                                              method: "autocompleteLead",
                                              "data-key": "full_name",
                                              placeholder: "Leads",
                                              disable: !_vm.selectedBusiness,
                                              "min-characters": 1
                                            },
                                            on: {
                                              change: _vm.leadAutocompleteChange
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "col-md-2 col-xs-12 q-mb-sm" },
                            [
                              _c("q-btn", {
                                attrs: {
                                  dense: "",
                                  disable: !_vm.selectedBusiness,
                                  label: "New lead",
                                  "no-caps": ""
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.startWithNewLead($event)
                                  }
                                }
                              }),
                              _vm.lead && _vm.lead.phone_number
                                ? _c(
                                    "sd-copy-to-clipboard",
                                    {
                                      staticClass: "ml-3",
                                      attrs: {
                                        copy: _vm.lead.phone_number,
                                        "with-icon": true
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.lead.phone_number) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      : _vm.selectedAgent === "post-tour-agent"
                      ? _c(
                          "div",
                          { staticClass: "col-md-2 col-xs-12 q-mb-sm" },
                          [
                            _c(
                              "div",
                              { staticClass: "row no-wrap items-end" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col" },
                                  [
                                    _c("q-select", {
                                      ref: "tourSelect",
                                      attrs: {
                                        options: _vm.completedTourOptions,
                                        "stack-label": "Select Completed Tour"
                                      },
                                      on: { input: _vm.onTourSelect },
                                      model: {
                                        value: _vm.selectedTour,
                                        callback: function($$v) {
                                          _vm.selectedTour = $$v
                                        },
                                        expression: "selectedTour"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "q-ml-sm" },
                                  [
                                    _c("q-btn", {
                                      attrs: {
                                        flat: "",
                                        dense: "",
                                        round: "",
                                        loading: _vm.isReloadingTours,
                                        disable: _vm.isReloadingTours,
                                        icon: "refresh",
                                        title: _vm.isReloadingTours
                                          ? "Refreshing…"
                                          : "Refresh tours"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.reloadToursAndOpen($event)
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.isPromptViewVisible
        ? _c(
            "div",
            { staticClass: "col-md-6 col-xs-12" },
            [
              _c(
                "q-card",
                { staticClass: "full-height" },
                [
                  _c("q-card-main", { staticClass: "system-prompt-main" }, [
                    _vm.systemPromptLoading
                      ? _c(
                          "div",
                          { staticClass: "text-center q-pa-md" },
                          [
                            _c("q-spinner-puff", {
                              attrs: { size: "30px", color: "primary" }
                            }),
                            _c("div", { staticClass: "q-mt-sm text-grey-6" }, [
                              _vm._v(
                                "\n              Loading prompt...\n            "
                              )
                            ])
                          ],
                          1
                        )
                      : _vm.systemPrompt
                      ? _c("div", { staticClass: "system-prompt-wrapper" }, [
                          _c("div", {
                            staticClass: "system-prompt-text",
                            domProps: { innerHTML: _vm._s(_vm.systemPrompt) }
                          })
                        ])
                      : _c(
                          "div",
                          { staticClass: "text-grey-6 text-center q-pa-md" },
                          [
                            _vm._v(
                              "\n            No system prompt available\n          "
                            )
                          ]
                        )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.isPromptViewVisible
        ? _c(
            "div",
            { staticClass: "col-md-6 col-xs-12" },
            [
              _c(
                "q-card",
                {
                  ref: "chatTimeline",
                  staticClass: "full-height column no-wrap",
                  attrs: { id: "chat-timeline" }
                },
                [
                  _c(
                    "q-card-title",
                    { staticClass: "row items-center justify-between" },
                    [
                      _c("div", { staticClass: "text-subtitle1" }, [
                        _vm._v("\n            Chat\n          ")
                      ]),
                      _c("q-btn", {
                        attrs: {
                          color: "negative",
                          flat: "",
                          dense: "",
                          loading: _vm.isResettingConversation,
                          disable:
                            !_vm.lead ||
                            !_vm.lead.conversation ||
                            !_vm.lead.conversation.id ||
                            _vm.isResettingConversation,
                          label: "Reset Conversation",
                          "no-caps": ""
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.resetConversation($event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-card-main",
                    { staticClass: "relative-position scrollable-wrapper col" },
                    [
                      _vm.messagesLoading
                        ? _c(
                            "div",
                            { staticClass: "text-center q-pa-md" },
                            [
                              _c("q-spinner-puff", {
                                attrs: { size: "50px", color: "primary" }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "q-mt-md text-primary text-bold"
                                },
                                [
                                  _vm._v(
                                    "\n              Loading messages...\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm.messages.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-center text-grey-6 q-pa-md" },
                            [
                              _vm._v(
                                "\n            No messages yet\n          "
                              )
                            ]
                          )
                        : _vm._l(_vm.messagesByDays, function(
                            messagesByDay,
                            date,
                            index
                          ) {
                            return _c(
                              "div",
                              { key: index },
                              [
                                _c(
                                  "q-chip",
                                  {
                                    staticClass: "event-date-chip",
                                    attrs: {
                                      dense: "",
                                      color: "blue",
                                      "text-color": "white"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(date) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._l(messagesByDay, function(message) {
                                  return _c(
                                    "div",
                                    {
                                      key: message.id,
                                      staticClass: "message-wrapper"
                                    },
                                    [
                                      message.direction === "outgoing"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "outgoing-message-wrapper"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#59B380"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        message.sending_agent ||
                                                          message.causer ||
                                                          "Agent"
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "message-body" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(message.body) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      message.created_at
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e(),
                                      message.direction === "incoming"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "incoming-message-wrapper"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticStyle: {
                                                    color: "#41A5F5"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.lead &&
                                                          _vm.lead.full_name
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "message-body" },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(message.body) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.dateInHumanFormat(
                                                      message.created_at
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          })
                    ],
                    2
                  ),
                  _c("q-card-separator"),
                  _c("q-card-main", { staticClass: "row gutter-xs" }, [
                    _c(
                      "div",
                      { staticClass: "col-11" },
                      [
                        _c(
                          "q-field",
                          [
                            _c("q-input", {
                              attrs: {
                                type: "textarea",
                                rows: 2,
                                placeholder: "Type a message to the agent"
                              },
                              model: {
                                value: _vm.textMessageToAgent,
                                callback: function($$v) {
                                  _vm.textMessageToAgent = $$v
                                },
                                expression: "textMessageToAgent"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-1" },
                      [
                        _c("q-btn", {
                          attrs: {
                            disabled:
                              _vm.textMessageToAgent === "" || _vm.smsIsSending,
                            loading: _vm.smsIsSending,
                            rounded: "",
                            size: "md",
                            label: "Send",
                            "no-caps": ""
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.sendTextToAgent()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.isPromptViewVisible
        ? _c(
            "div",
            { staticClass: "col-xs-12" },
            [
              _c(
                "q-card",
                { staticClass: "full-height" },
                [
                  _c(
                    "q-card-main",
                    { staticClass: "text-center q-pa-xl" },
                    [
                      _c("q-icon", {
                        attrs: { name: "chat", size: "80px", color: "grey-5" }
                      }),
                      _c("h5", { staticClass: "text-grey-6 q-mt-lg" }, [
                        _vm._v(
                          "\n            Select agent, prompt version and lead, then click Set\n          "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }